import { useTranslation } from 'react-i18next';
import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import './dashboard.css';
// * Constants
import { HISTORICAL_INFO, EXISTING_BENEFITS, PROJECTION_PERIOD, ESTIMATION_GAPS, COVERED_POPULATION, FINANCIAL_PROJECTION, RESULTS, INDICATORS, GRAPHICS} from './constants'
// * Kendo
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

// * Helpers
import API from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import MatrixContext from '../../assets/Constants/matrixContext';
/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";

function Dashboard() {
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    /**Used to translate the text*/
    const { t } = useTranslation('common');
    /**We use useHistory hook to redirect */
    const history = useHistory();
    // States
    const [showingInputs, setShowingInputs] = useState(true)
    // percentage
    // const [historicalPercentage, setHistoricalPercentage] = useState(0);
    // const [demographicPercentage, setDemographicPercentage] = useState(0);
    // const [economicPercentage, setEconomicPercentage] = useState(0);
    /** State of the dialog. True = showing ... False = hidden */
    const [showAlert, setShowAlert] = useState(false);
    // Session context to get the current institution data
    const { user } = useContext(AuthContext);

    /**Triggered when user clicks "Go Back" button. Redirects to Models view*/
    const goBack = () => {
        history.push('/Scenarios');
    }

    // Show or hide the alert dialog. See state variable
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    }

    /**Sets the state to true, it means that the Inputs div will appear with green background*/
    const onInputsClick = () => {
        setShowingInputs(true);
    }

    /**Sets the state to false, it means that the Outputs div will appear with green background*/
    const onOutputsClick = () => {
        setShowingInputs(false);
    }

    // Navigates to the matrix control with the code of the node that should be open in the tree
    const onHist_info_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: HISTORICAL_INFO,
                detail: location.state.detail
            }
        });
    }

    const onDemog_info_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: EXISTING_BENEFITS,
                detail: location.state.detail
            }
        });
    }

    const onEcon_fin_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: PROJECTION_PERIOD,
                detail: location.state.detail
            }
        });
    }

    const on_estimation_gap_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: ESTIMATION_GAPS,
                detail: location.state.detail
            }
        });
    }

    const on_covered_pop_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: COVERED_POPULATION,
                detail: location.state.detail
            }
        });
    }

    const on_financial_pro_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: FINANCIAL_PROJECTION,
                detail: location.state.detail
            }
        });
    }


    const on_graphics_click = () => {
        history.push({
            pathname: '/Graph',
            state: {
                code: GRAPHICS,
                detail: location.state.detail
            }
        });
    }

    const on_results_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: RESULTS,
                detail: location.state.detail
            }
        });
    }

    const on_indicators_click = () => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: INDICATORS,
                detail: location.state.detail
            }
        });
    }

    //* When user clicks the Calculate button
    const onCalculate = async () => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${location.state.detail.scenarioId}&userCode=${user.email}`);
            const isCehckoutRes = await API.get(`/Scenario/IsCheckout?scenarioId=${location.state.detail.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            if (isCehckoutRes.data.code !== 100) {
                Notifications.notify(isCehckoutRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;
            const isCheckoutData = isCehckoutRes.data.data;


            // * If model is not lock by other user
            if (!isLockData.isLock && !isCheckoutData) {
                await API.get(`/Scenario/LockScenario?scenarioId=${location.state.detail.scenarioId}&userCode=system`);
                const response = await API.post(`Scheduler/addTask`, null, {
                    params: {
                        ctxtcode: MatrixContext.SCENARIO,
                        scenarioid: location.state.detail.scenarioId,
                        opcode: 'CAL',
                        usrcode: user ? user.email : 'get_user_error',
                        customparams: JSON.stringify({ runblocks: ['load_data', 'gaps', 'projections', 'calc_rpt', 'make_reports'] })
                    }
                });
                if (response.data.code !== 100) {
                    Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                    toggleAlert();
                    return;
                }
                Notifications.notify(t('scenarios.calculate_success'), SUCCESS_NOTIFICATION);
                toggleAlert();
            } else {
                // **** If not, error is displayed
                if (isLockData.isLock) {
                    Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                    return;
                } else if (isCheckoutData) {
                    Notifications.notify(t('scenarios.add_benefit.ischeckout'), ERROR_NOTIFICATION);
                    return;
                }
            }
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    return (
        <>
            {showAlert &&
                <Dialog
                    className="ilo-delete-confirm"
                    title={t('scenarios.calculate_title')}
                    onClose={() => toggleAlert()}
                >
                    <p style={{ margin: "25px", textAlign: "center" }}>{t('scenarios.calculate_body')}</p>
                    <DialogActionsBar layout="end">
                        <button className="k-button" onClick={onCalculate}>{t('alerts.yes_btn')}</button>
                        <button className="k-button" onClick={toggleAlert}>{t('alerts.no_btn')}</button>
                    </DialogActionsBar>
                </Dialog>
            }
            <div>
                <div className="sub_menu">
                    <div className="sub_menu_btns my-1">
                        <button className="ilo-btn wizard_goBack_btn" onClick={goBack}> <BiArrowFromRight /> {t('scenarios.goBack')}</button>
                        <button className="btn btn-primary ilo-btn" onClick={toggleAlert}>{t('scenarios.calculate_button')}</button>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <div className="container main_container">
                                <div className="row scenario_name_row">{location.state.detail.name}</div>
                                <div className="row buttons_row">
                                    <div className={`col-sm-6 col-md-6 col-lg-6 buttons ${showingInputs ? 'active_button' : ''}`} onClick={onInputsClick}>{t('scenarios.dashboard_btnInputs')}</div>
                                    <div className={`col-sm-6 col-md-6 col-lg-6 buttons ${showingInputs ? '' : 'active_button'}`} onClick={onOutputsClick}>{t('scenarios.dashboard_btnOutputs')}</div>
                                </div>
                                {
                                    showingInputs ?
                                        <>
                                            {/**Inputs dashboard*/}
                                            <div className="row first_row_dashboard">
                                                <div className="col-md-6 first_row_element" onClick={onHist_info_click}>
                                                    <div className="row justify-content-center align-items-end hist_info_text_div">
                                                        <h5>{t('scenarios.dashboard_historical_titile')}</h5>
                                                    </div>
                                                    <div className="row justify-content-end align-items-end hist_info_percentage_div">
                                                        <h3 className="pct_space">{/**{historicalPercentage}%*/}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 first_row_element" onClick={onDemog_info_click}>
                                                    <div className="row justify-content-center align-items-end demo_info_text_div">
                                                        <h5>{t('scenarios.dashboard_demographic_titile')}</h5>
                                                    </div>
                                                    <div className="row justify-content-end align-items-end demo_info_percentage_div">
                                                        <h3 className="pct_space">{/*{demographicPercentage}%*/}</h3>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row second_row_dashboard">
                                                <div className="col-md-12 second_row_element" onClick={onEcon_fin_click}>
                                                    <div className="row justify-content-center align-items-end econ_finan_text_div">
                                                        <h5>{t('scenarios.dashboard_economic_titile')}</h5>
                                                    </div>
                                                    <div className="row justify-content-end align-items-end econ_finan_percentage_div">
                                                        <h3 className="pct_space">{/*{economicPercentage}%*/}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            {/**Outputs dashboard*/}
                                            <div className="row first_row_dashboard">
                                                <div className="col-md-4 first_row_element" onClick={on_estimation_gap_click}>
                                                    <div className="row justify-content-center align-items-center demo_info_text_div_output">
                                                        <h5>{t('scenarios.dashboard_gaps_title')}</h5>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 first_row_element" onClick={on_covered_pop_click}>
                                                    <div className="row justify-content-center align-items-center hist_info_text_div_output">
                                                        <h5>{t('scenarios.dashboard_assessment_title')}</h5>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 first_row_element" onClick={on_indicators_click}>
                                                    <div className="row justify-content-center align-items-center indicators_text_div_output">
                                                        <h5>{t('scenarios.dashboard_indicators_title')}</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row second_row_dashboard">
                                                <div className="col-md-4 second_row_element" onClick={on_financial_pro_click}>
                                                    <div className="row justify-content-center align-items-center econ_finan_text_div_output">
                                                        <h5>{t('scenarios.dashboard_finan_projection_title')}</h5>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 second_row_element" onClick={on_graphics_click}>
                                                    <div className="row justify-content-center align-items-center graph_text_div_output">
                                                        <h5>{t('scenarios.dashboard_graphics_title')}</h5>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 second_row_element" onClick={on_results_click}>
                                                    <div className="row justify-content-center align-items-center result_text_div_output">
                                                        <h5>{t('scenarios.dashboard_reports_title')}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                }
                            </div>

                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default Dashboard